<template>
    <div></div>    
</template>

<script>
import {
  verifyOTPService
} from "@/services/auth.service.js";
import constants from '@/constants.js';

export default {
    data() {
        return {
            constants
        }
    },
    computed: {
        invitePhrase() {
            return this.$route.params.invitePhrase;
        },
        isUserLoggedIn() {
            return this.$store.state.auth.isUserLoggedIn;
        },
    },
    methods: {
        verifyUser(email, loginCode, redirectTo) {
            const payload = {
                redirectTo,
                email,
                otp: loginCode,
                currentThis: this,
                userSource: 'magicLinkAutoLogin',
            };
            

            verifyOTPService(payload);
        },
        goToLogin() {
            window.location.href = '/user/dashboard';
        }
    },
    mounted() {
        this.$vs.loading();


        if(!this.invitePhrase) {
            this.$vs.loading.close();

            this.goToLogin();
        } else {
            this.$store.dispatch('auth/decryptInvitePhrase', { invitePhrase: this.invitePhrase })
            .then(res => {
                const email = res.data.inviteData.email;
                const loginCode = res.data.inviteData.loginCode;
                const redirectTo = res.data.inviteData.redirectTo;
                if(this.isUserLoggedIn) {
                    this.$vs.loading.close();
                    if(redirectTo) {
                        window.location.href = redirectTo;
                    } else {
                        this.goToLogin();
                    }
                } else if(email && loginCode) {
                    this.verifyUser(email, loginCode, redirectTo);
                } else {
                    this.$vs.loading.close();
                    
                    this.goToLogin();
                }
            }).catch(err => {
                this.$vs.loading.close();

                // throw err;
                this.goToLogin();
            });
        }
    },
    created() {}
}
</script>
